import { useContext } from 'react'
import { OnboardingV3Context } from 'context/onboarding-v3'

export const useOnboardingModalState = () => {
  const context = useContext(OnboardingV3Context)

  if (!context) {
    return {
      registerModalOpen: () => {},
      registerModalClosed: () => {},
      isAnyModalOpen: false
    }
  }

  return {
    registerModalOpen: context.registerModalOpen,
    registerModalClosed: context.registerModalClosed,
    isAnyModalOpen: context.openModalCount > 0
  }
}
